import modals from '../modal'

export default (function () {
  'use strict';

  let reviewData;
  let reviewSlider;
  let reviewSliderTriggers;
  let reviewSliderNext;
  let reviewSliderPrev;
  let interval;
  const reviewGrid = document.querySelector('.acuity--quotes-container')

  function showReviewDetail(reviewUri) {

    const reviewDetails = reviewData[reviewUri]
    const nextPrevDetails = Object.keys(reviewData);
    const currentIndex = nextPrevDetails.indexOf(reviewUri)

    const reviewDetailsContainer = reviewSlider
    const titleElem = reviewDetailsContainer.querySelector('[data-review-title]')
    reviewSlider.querySelector('.quote').scrollTo(0, 0);
    const copyElem = reviewDetailsContainer.querySelector('[data-review-copy]')
    const numberElem = reviewGrid.querySelector('.carousel-status');

    let prevElem = reviewDetailsContainer.querySelector('[data-review-uri-prev]')
    let nextElem = reviewDetailsContainer.querySelector('[data-review-uri-next]')


    titleElem.innerHTML = reviewDetails.title
    copyElem.innerHTML = reviewDetails.quote

    if (currentIndex + 1 < 10) {
      numberElem.innerHTML = '0' + (currentIndex + 1)
    } else {
      numberElem.innerHTML = currentIndex + 1
    }

    // Get the details of the next person

    if (currentIndex === nextPrevDetails.length - 1) {
      let nextArea = nextPrevDetails[0];
      nextElem.setAttribute('data-review-uri-next', nextArea);

    } else {
      let nextArea = nextPrevDetails[currentIndex + 1];
      nextElem.setAttribute('data-review-uri-next', nextArea);
    }

    if (currentIndex === 0) {
      let end = nextPrevDetails.length
      let prevArea = nextPrevDetails[end - 1];
      prevElem.setAttribute('data-review-uri-prev', prevArea);
    } else {
      let prevArea = nextPrevDetails[currentIndex - 1];
      prevElem.setAttribute('data-review-uri-prev', prevArea);
    }
  }

  function autoPlay(reviewUri) {
    let index = 0;
    const nextPrevDetails = Object.keys(reviewData);
    showReviewDetail(Object.keys(reviewData)[index]);

    interval = setInterval(function () {
      showReviewDetail(Object.keys(reviewData)[index]);
      if (nextPrevDetails.length - 1 === index) {
        index = 0;
      } else {
        index++;
      }
    }, 15000);
  }

  function clearReviewDetail() {
    reviewSlider.querySelector('.quote-copy').scrollTo(0, 0);
    const reviewDetailsContainer = reviewSlider

    const titleElem = reviewDetailsContainer.querySelector('[data-review-title]')
    const copyElem = reviewDetailsContainer.querySelector('[data-review-copy]')
    const numberElem = reviewDetailsContainer.querySelector('.carousel-status');

    numberElem.innerHTML = ''
    titleElem.innerHTML = ''
    copyElem.innerHTML = ''
  }

  function handleReviewTriggerClick(event) {
    event.preventDefault()
    showReviewDetail(event.target.dataset.reviewUri)
  }

  function setupReviewGrid() {
    reviewData = JSON.parse(document.getElementById('ReviewsData').textContent.trim())

    reviewSlider = document.querySelector('.acuity--quotes-container')
    reviewSliderNext = reviewSlider.querySelector('.js-next-slider')
    reviewSliderPrev = reviewSlider.querySelector('.js-prev-review')

    autoPlay()

    reviewSliderNext.addEventListener('click', handleNextReviewClick)
    reviewSliderPrev.addEventListener('click', handlePreviousReviewClick)

  }

  function handleNextReviewClick(event, reviewUri) {
    clearInterval(interval);
    event.preventDefault()
    reviewSlider.querySelector('.quote-copy').scrollTo(0, 0);
    showReviewDetail(event.target.dataset.reviewUriNext)
  }

  function handlePreviousReviewClick(event, teamUri) {
    clearInterval(interval);
    event.preventDefault()

    showReviewDetail(event.target.dataset.reviewUriPrev)
  }


  function init() {
    if (!reviewGrid) {
      return;
    }
    window.addEventListener('DOMContentLoaded', () => {
      setupReviewGrid()
    })
  }

  return {
    init,
  }

})();
